import React, { useState } from 'react';
import { pickDomAttrs } from '../../_util/utils';
import Text from '../../text';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoteEditor = _ref => {
  let {
    value = '',
    disabled,
    palceholder,
    onCheck,
    rules,
    inputWidth,
    ...restProps
  } = _ref;
  const attrs = pickDomAttrs(restProps);
  const [editing, onEditingChange] = useState(false);
  if (disabled) {
    return /*#__PURE__*/_jsx(Text, {
      children: value || '-'
    });
  }
  if (editing || value) {
    return /*#__PURE__*/_jsx(Text, {
      editable: {
        editing,
        onEditingChange,
        onCheck,
        inputWidth,
        rules
      },
      children: value
    });
  }
  return /*#__PURE__*/_jsx("a", {
    ...attrs.data,
    className: "note-editor-placeholder",
    onClick: () => {
      onEditingChange(true);
    },
    children: palceholder
  });
};